// @flow

import React from "react";
import { View, Text, ViewStyle, TextStyle } from "react-native";
import { radioButtonStyles as styles } from "./styles";
import { TouchableOpacity } from "../Buttons";
import Button from "./Button";

type RadioButtonProps = {
  onChoicePress: () => void;
  text: string;
  enabled: boolean;
  customRadioButtonStyles?: { container?: ViewStyle; buttonText?: TextStyle };
  customButtonStyles?: {
    radioButtonContainer?: ViewStyle;
    radioButtonEnabled?: ViewStyle;
  };
};

const RadioButton = ({
  onChoicePress,
  text,
  enabled,
  customRadioButtonStyles,
  customButtonStyles,
}: RadioButtonProps): JSX.Element => {
  return (
    <TouchableOpacity
      onPress={onChoicePress}
      style={[styles.container, customRadioButtonStyles?.container]}
    >
      <Button enabled={enabled} customButtonStyles={customButtonStyles} />
      <View style={styles.textContainer}>
        <Text style={[styles.buttonText, customRadioButtonStyles?.buttonText]}>
          {text}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default RadioButton;
